import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  TOKEN_EXP,
  ID_TOKEN,
} from '../../constants/applicationConstants';
import { parseStoredTokenExpiry } from './authorization';
/**
 * Returns an object with id, access, and refresh tokens retrieved from session storage.
 * tokenExp is returned as a number (seconds since epoch) when available.
 * @function getTokensFromStorage
 * @returns {Object} An object containing accessToken, idToken, refreshToken, tokenExp.
 */
export const getTokensFromStorage = () => ({
  accessToken: sessionStorage.getItem(ACCESS_TOKEN),
  idToken: sessionStorage.getItem(ID_TOKEN),
  refreshToken: sessionStorage.getItem(REFRESH_TOKEN),
  tokenExp: parseStoredTokenExpiry(sessionStorage.getItem(TOKEN_EXP)),
});
export default getTokensFromStorage;
